/*!
 * jQuery Accordion
 *
 * Copyright 2014 Web Agency Meta Line S.r.l.
 * Released under the MIT license
 */

(function ($) {

    "use strict";

    if (!$.ML) {
        $.ML = {};
    }

    var
        pluginName = 'accordion',
        defaults = {
            panelSelector: '.accordion-panel',
            titleSelector: '.accordion-title',
            contentSelector: '.accordion-content',
            activeClass: 'active',
            duration: 'slow',
            anchor: true,
            openOnlyOne: true,
            onOpen: function (panel) {},
            onOpenComplete: function (panel) {},
            levelString: 'accordion-level'
        },
        pub = {};

    // Destroy
    pub.destroy = function () {
        return $(this).each(function () {
            var $el = $(this),
                base = $el.data(pluginName),
                regex = new RegExp(base.options.levelString + '\\d{1,3}');

            base.panels
                .off('click', base.options.titleSelector, base.onTitleClick)
                .removeClass(base.options.activeClass);

            $el.find('[class*="' + base.options.levelString + '"]').removeAttr('style').removeClass(function () {
                var result = [],
                    classes = this.className.split(' '),
                    i = 0, l = classes.length;

                for (; i < l; i++ ) {
                    if (regex.test(classes[i])) {
                        result.push(classes[i]);
                    }
                }

                return result.join(' ');
            });

            base.status = 'destroy';
        });
    };

    // Pause
    pub.pause = function () {
        return $(this).each(function () {
            var $el = $(this),
                base = $el.data(pluginName);

            base.panels
                .off('click', base.options.titleSelector, base.onTitleClick);
        });
    };

    // Restart
    pub.restart = function () {
        return $(this).each(function () {
            var $el = $(this),
                base = $el.data(pluginName);

            if (base.status === 'pause') {
                // pause
                base.panels
                    .on('click', base.options.titleSelector, base.onTitleClick);
            } else {
                // destroy or other
                base.init();
            }
        });
    };

    $.ML[pluginName] = function (element, options) {
        var base = this;

        base.el = element;
        base.$el = $(element);

        base.$el.data(pluginName, base);

        // Public methods
        if (pub[options]) {
            return pub[options]();
        }

        base.init = function () {
            var panel;

            base.options = $.extend({}, defaults, options);
            base.status = 'run';

            // Selector trim
            base.options.panelSelector = $.trim(base.options.panelSelector);
            base.options.titleSelector = $.trim(base.options.titleSelector);
            base.options.contentSelector = $.trim(base.options.contentSelector);

            // Panels & contents
            base.panels = base.$el.find(base.options.panelSelector);
            base.contents = base.panels.find(base.options.contentSelector).each(function () {
                var el = $(this),
                    level = el.parents(base.options.panelSelector).length - 1;

                el
                    .addClass(base.options.levelString + level)
                    .data(base.options.levelString, level)
                    .hide();
            });

            // Attach the title click event
            base.panels.on('click', base.options.titleSelector, base.onTitleClick);

            // Anchor
            if (base.options.anchor && window.location.hash) {
                panel = base.$el.find(window.location.hash).closest(base.options.panelSelector);

                panel.addClass(base.options.activeClass);
            } else {
                panel = base.$el.find(base.options.panelSelector + '.' + base.options.activeClass);
            }

            // Active panels must be opened
            panel.find(base.options.contentSelector).show();
        };

        // Title click event callback
        base.onTitleClick = function (event) {
            event.preventDefault();

            var
                title = $(this),
                panel = title.closest(base.options.panelSelector),
                content = panel.find(base.options.contentSelector),
                level = content.data(base.options.levelString),
                collapsible;

            base.options.onOpen(panel);

            if (base.options.openOnlyOne) {
                if (content.data(base.options.levelString) === 0) {
                    collapsible = base.$el.find('.' + base.options.levelString + '0');
                } else {
                    collapsible = panel
                        .closest('.' + base.options.levelString + (level - 1))
                        .find('.' + base.options.levelString + level);
                }
            } else {
                // I can collapse only itself
                collapsible = content;
            }

            collapsible = collapsible.filter(':visible');

            // Here I use promises to resolve options.onOpenComplete always
            $.when(content.slideDown(base.options.duration), collapsible.slideUp(base.options.duration))
                .done(function () {
                    base.options.onOpenComplete(panel);
                });

            // options.activeClass
            if (panel.hasClass(base.options.activeClass)) {
                base.panels.removeClass(base.options.activeClass);
            } else {
                base.panels.removeClass(base.options.activeClass);
                panel.addClass(base.options.activeClass);
            }
        };

        return base;
    };

    // Plugin
    $.fn[pluginName] = function (options) {

        if (pub[options]) {
            return pub[options].apply(this, Array.prototype.slice.call(arguments, 1));
        } else {
            return this.each(function () {
                var plugin = new $.ML[pluginName](this, options);
                plugin.init();
            });
        }

    };

}(jQuery));
